module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Modern-Day Palmistry")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_c('strong', [_vm._v("About the Author")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_c('strong', [_vm._v("Copyright Information ©")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#introduction"
    }
  }, [_c('strong', [_vm._v("Introduction")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0001#first-thing-is-to-get-to-know-the-hand-by-the-common-palmistry-terms",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("First Thing Is to Get to Know the Hand by the Common Palmistry Terms")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0002#do-we-read-both-hands",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Do We Read Both Hands?")])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#chapter-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 1: ")]), _vm._v("Jupiter – The Index Finger")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#jupiter-the-index-finger",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#chapter-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 2:")]), _vm._v("Saturn – The Middle Finger")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#saturn-the-middle-finger",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 3: ")]), _vm._v("Apollo – The Ring Finger")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#apollo-the-ring-finger",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 4:")]), _vm._v("Mercury – The Little Finger")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#mercury-the-little-finger",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 5:")]), _vm._v("The Thumb")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-thumb",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 6:")]), _vm._v("The Fingers in General")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#the-fingers-in-general",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 7:")]), _c('em', [_vm._v("Puffy, Thick Bottom Joints")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#puffy-thick-bottom-joints",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0019#thin-bottom-joints",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Thin Bottom Joints")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0019#smooth-fingers",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Smooth Fingers")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0019#knotty-knuckles",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Knotty Knuckles")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0020#angle-of-dexterity",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Angle of Dexterity")])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 8:")]), _c('em', [_vm._v("Size")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#size",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#fingernails",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Fingernails")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#fingertips",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fingertips")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 9: ")]), _vm._v("Hands Shapes")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#hands-shapes",
      "title": "Link target outside of Sample"
    }
  }), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#section",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#section-1",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#section-2",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#earth-hands",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Earth Hands")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#water-hands",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Water Hands")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0022#fire-hands",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Fire Hands")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0022#air-hands",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Air Hands")])])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 10:")]), _c('em', [_vm._v("Procrastination Lines")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#procrastination-lines",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0023#texture",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Texture")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0024#freckles-moles-and-warts",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Freckles, Moles, and Warts")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0024#temperament",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Temperament")])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 11:")]), _vm._v("Skin Ridge Patterns")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#skin-ridge-patterns",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 12:")]), _vm._v("Fingerprints")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#fingerprints",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 13:")]), _vm._v("Timing on the Hand")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#timing-on-the-hand",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 14:")]), _vm._v("Heart Line")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#heart-line",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 15:")]), _vm._v("Head Line")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#head-line",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 16:")]), _vm._v("My Opinion of Health in the Hands")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#my-opinion-of-health-in-the-hands",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 17:")]), _vm._v("Life Line")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#life-line",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 18:")]), _vm._v("Fate or Work Line")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#fate-or-work-line",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 19:")]), _vm._v("Line of the Sun")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#line-of-the-sun",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 20:")]), _c('em', [_vm._v("Success in Business")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#success-in-business",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0063#the-health-line-or-line-of-intuition",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Health Line or Line of Intuition")])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 21:")]), _c('em', [_vm._v("Travel Lines")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#travel-lines",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0065#cruise",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Cruise")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0066#raclettes",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Raclettes")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0066#rings-of-solomon",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rings of Solomon")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0067#teachers-square",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teacher’s Square")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0068#sibling-lines",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Sibling Lines")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0068#the-money-maker-line",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("The Money-Maker Line")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0069#poison-line",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Poison Line")])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 22:")]), _c('em', [_vm._v("Upper Mars Mount")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#upper-mars-mount",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#lower-mars-mount",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lower Mars Mount")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0071#luna",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Luna")])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0072#neptune",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Neptune")])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 23:")]), _c('em', [_vm._v("Marriage Lines")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#marriage-lines",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Section0080#children",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Children")])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 24:")]), _vm._v("Markings Found Anywhere on the Hand and What They Mean")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#markings-found-anywhere-on-the-hand-and-what-they-mean",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Chapter 25:")]), _vm._v("Full Dummy Readings")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#full-dummy-readings",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#in-conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("In Conclusion")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0